(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        console.log(`FAQ's - Section`);
        const buttons = document.querySelectorAll('.faqs-section button');
        buttons.forEach(button => {
            button.addEventListener('click', function() {
                const expanded = this.getAttribute('aria-expanded') === 'true' || false;
                buttons.forEach(btn => {
                    btn.setAttribute('aria-expanded', 'false');
                    btn.nextElementSibling.hidden = true;
                });
                this.setAttribute('aria-expanded', !expanded);
                this.nextElementSibling.hidden = expanded;
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Get the #map element
  const mapElement = document.getElementById("map");

  // Retrieve latitude and longitude from data attributes
  const latitude = parseFloat(mapElement.dataset.latitude);
  const longitude = parseFloat(mapElement.dataset.longitude);

  console.log("Latitude:", latitude);
  console.log("Longitude:", longitude);

  if (isNaN(latitude) || isNaN(longitude)) {
    console.error("Invalid latitude or longitude values.");
    return; // Stop execution if values are invalid
  }

  const mapboxToken = "pk.eyJ1IjoiYWRhbWt3YWRzd29ydGgiLCJhIjoiY2phOXE0N21qMGo0cTMzcThkbDc5cjlneSJ9.c4WVlcu5CSrTdTa8EtP92g";

  mapboxgl.accessToken = mapboxToken;

  const map = new mapboxgl.Map({
    container: "map", // ID of the HTML container
    style: "mapbox://styles/mapbox/streets-v11",
    center: [longitude, latitude], // Center the map on coordinates
    zoom: 15, // Zoom level
    scrollZoom: false, // <- prevents wheel-scroll hijack
  });

  // Citrine-coloured marker
  new mapboxgl.Marker({ color: '#ff68a1' })
    .setLngLat([longitude, latitude])
    .addTo(map);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  /* ----------  tab / keyboard nav (unchanged) ---------- */
  const buttons = document.querySelectorAll('.collection-button');
  const panels  = document.querySelectorAll('.collection-content');
  const setTab = idx => {
    buttons.forEach((btn, i) => {
      const on = i === idx;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on);
      btn.setAttribute('tabindex', on ? '0' : '-1');
      panels[i].classList.toggle('is-active', on);
    });
  };
  buttons.forEach((btn, idx) => {
    btn.addEventListener('click', () => setTab(idx));
    btn.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { setTab((idx + 1) % buttons.length); e.preventDefault(); }
      if (e.key === 'ArrowLeft')  { setTab((idx - 1 + buttons.length) % buttons.length); e.preventDefault(); }
    });
    if (idx === 0) { btn.setAttribute('aria-selected', 'true'); btn.setAttribute('tabindex', '0'); }
    else { btn.setAttribute('aria-selected', 'false'); btn.setAttribute('tabindex', '-1'); }
  });
  if (buttons.length && panels.length) setTab(0);

  /* ----------  load remaining pages (server-side filtered) ---------- */
  const cfg   = JSON.parse(document.getElementById('menu-data').textContent);
  const loc   = cfg.location;
  const cardTpl = document.querySelector('.menu-card');        // first card = template

  cfg.collections.forEach(col => {
    if (col.total <= col.first50) return;                      // nothing to paginate
    let page = 2;                                                // liquid gave us page 1
    const loadPage = () =>
      fetch(`/collections/${col.handle}?view=cards-json&page=${page}&limit=50&loc=${loc}`)
        .then(r => r.text())
        .then(html => {
          const doc  = new DOMParser().parseFromString(html, 'text/html');
          const rows = doc.querySelectorAll('.menu-card');
          let added  = 0;
          rows.forEach(node => {
            /* clone template */
            const clone = cardTpl.cloneNode(true);
            clone.innerHTML = node.innerHTML;
            clone.dataset.locationTags = node.dataset.locationTags;
            clone.dataset.collection   = node.dataset.collection;
            /* drop into BOTH panels */
            const allPanel = document.getElementById('all').querySelector('.tw-grid');
            const colPanel = document.getElementById(col.handle).querySelector('.tw-grid');
            [allPanel, colPanel].forEach(p => p && p.appendChild(clone.cloneNode(true)));
            added++;
          });
          /* continue while we see a next link */
          if (added && doc.querySelector('.pagination .next a')) { page++; return loadPage(); }
        })
        .catch(console.error);
    loadPage();
  });

  /* ----------  ajax add-to-cart (unchanged) ---------- */
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const id = btn.dataset.variantId;
      btn.disabled = true;
      btn.classList.add('tw-opacity-50');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: Number(id), quantity: 1})
      })
      .then(r => r.json())
      .then(() => fetch('/cart?section_id=cart-drawer'))
      .then(r => r.text())
      .then(html => {
        const newDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        const curDrawer = document.querySelector('cart-drawer');
        if (newDrawer && curDrawer) {
          curDrawer.innerHTML = newDrawer.innerHTML;
          if (typeof curDrawer.open === 'function') curDrawer.open();
        }
      })
      .catch(err => alert('Error adding to cart'))
      .finally(() => { btn.disabled = false; btn.classList.remove('tw-opacity-50'); });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
